import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import {NeoGlobalService, NeoStorageService} from 'ng-neo';
import {NeoJWTService} from "../services/neo-jwt/neo-jwt";
import {NeoACLService} from "../services/neo-acl/neo-acl";

@Injectable()
export class CanAccessGuard implements CanActivate {
    constructor(private _storage: NeoStorageService,
                private _gs: NeoGlobalService,
                private _acl: NeoACLService,
                private router: Router,
                private _jwt: NeoJWTService) {
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return Observable.create((observer) => {
            // Comprobamos si existe el usuario y comprobamos que el token es valido
            const token = this._jwt.getToken();
            if (!this._storage.existsInLocalStorage('user') && !token.isValid()) {

                this._gs.set('isLogin', false);
                observer.next(false);
                observer.complete();
                return;
            }

            if (!this.hasAccess(next)) {
                this.router.navigateByUrl("/dashboard");
            }

            observer.next(true);
            observer.complete();
            return;
        });
    }

    /**
     * Comprueba si tiene los permisos acl de la ruta
     * @param {ActivatedRouteSnapshot} next
     * @returns {boolean}
     */
    private hasAccess(next: ActivatedRouteSnapshot) {
        if (next.data && next.data.acl && next.data.acl.length > 0) {
            return this._acl.can(next.data.acl);
        }

        if (next.children.length > 0) {
            for (const c of next.children) {
                let can = this.hasAccess(c);

                if (!can) {
                    return false;
                }
            }
        }

        return true
    }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/can-access.guard.ts